import React from 'react';
import { Button } from "@/components/ui/button.tsx";
import { cn } from "@/lib/utils.ts";

const FloatingButton = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      size="icon-xl"
      className={cn(
        "rounded-full shadow-[4px_4px_8px_0px_rgba(0,0,0,0.35)] bg-black/90 hover:bg-black/60 cursor-pointer text-white transition-all",
        "size-12 md:size-16", // Responsive sizing: smaller on mobile, larger on desktop
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
});

FloatingButton.displayName = "FloatingButton";

export { FloatingButton };
